// extracted by mini-css-extract-plugin
export default {"container":"MessagesPageDetails_container__waMNn"};